import { Injectable } from '@angular/core';
import {  NavigationStart, Router } from '@angular/router';
import { PopupControl } from './models/popup-control.model';
import { SelectionSet } from './pages/settings/settings.service';
import { NotificationService } from './services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class SelectionOptionsPopUpService {

	public popupControl: PopupControl = new PopupControl(
		{
			width: '80%',
			height: '80%',
		}
	);

	public selectionSets: SelectionSet[] = [];

	public addSelectionSet(selectionSet: SelectionSet): void {
		if (this.selectionSets.find((item) => item.selectionSetId === selectionSet.selectionSetId)) {
			return;
		}

		this.selectionSets.push(selectionSet);
	}

	public reset(): void {
		this.popupControl.options.title = null;
		this.popupControl.description = null;

		this.selectionSets = [];

		// this._settingsMap = new Map<string, any[]>();

		
	}

	constructor(
		private _router: Router,
		private _notificationService: NotificationService,
	) {
		this._router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationStart) {
					this.reset();
				}
			}
		);
	}
}
